
import { isImage, isVideo } from 'vessel/utils'
import { isVideoEmbed, videoEmbedAttrs } from './video'

export default {
  name: 'VsEmbed',
  inheritAttrs: false,
  props: {
    source: {
      type: String,
      default: null
    },
    src: {
      type: String,
      default: null
    },
    ratio: {
      type: [String, Boolean, Object],
      default: '16/9'
    },
    fit: {
      type: [String, Object],
      default: 'cover'
    },
    thumbnail: {
      type: Boolean,
      default: false
    }
  },
  vessel: {
    ratio: {
      $attrs: ['width', 'height'],
    },
    object: {
      $attrs: 'all',
      width: 'full',
      maxWidth: 'full',
      height: 'full',
      maxHeight: 'full',
      $fit: 'objectFit'
    },
    slot: {
      position: 'absolute',
      pin: true,
      width: 'full',
      height: 'full',
      pointerEvents: 'none'
    }
  },
  data() {
    return {
      loaded: false
    }
  },
  computed: {
    href() {
      return this.src || this.source
    },
    attrs() {
      const { href, ratio, fit } = this
      return { ...this.$attrs, src: href, ratio, fit }
    },
    hasContent() {
      const slots = this.$slots.default
      return slots && slots.length
    },
    isVideoEmbed() {
      return isVideoEmbed(this.href)
    },
    isVideoThumb() {
      return this.thumbnail && this.isVideoEmbed && this.tagAttrs.poster
    },
    component() {
      return isVideo(this.href) ? 'vs-video' : isImage(this.href) ? 'vs-image' : null
    },
    tag() {
      return this.isVideoEmbed ? 'iframe' : 'embed'
    },
    tagAttrs() {
      if (this.isVideoEmbed) {
        const { options, ...attrs } = this.attrs
        const { src, poster } = videoEmbedAttrs(this.href, options)

        return { ...attrs, src, poster }
      }

      return this.attrs
    }
  },
  methods: {
    onLoad(event) {
      this.loaded = true
      this.$emit('load', event)
    }
  }
}
